/**
 * Single source of truth for the Wefayo "Get Started" walkthrough.
 * Used by:
 *   - CommunityLayout  (Joyride desktop/web tour)
 *   - MainLayout        (Joyride desktop/web tour)
 *   - AsideRight        (mobile "Get Started" dialog)
 */

export const tourSteps = [
    {
        target: '#menu-link-log',
        title: 'Welcome to Wefayo!',
        content: 'Wefayo connects people with medical conditions, health issues, or special needs—along with their friends and families—to a supportive community of caring individuals, service and healthcare providers, employers, and resources.',
        disableBeacon: true,
    },
    {
        target: '#menu-link-communities',
        title: 'Communities',
        content: 'Explore and connect with different communities, make new friends, get inspired by success stories, share your knowledge, and access exclusive content.',
        disableBeacon: true,
    },
    {
        target: '#menu-link-ai-chat',
        title: 'Ask Wefayo AI',
        content: 'Chat with Wefayo AI, a virtual assistant that can help you with your questions and needs.',
        disableBeacon: true,
    },
    {
        target: '#menu-link-jobs',
        title: 'Jobs',
        content: 'Discover exciting career opportunities or post job listings for others to see.',
        disableBeacon: true,
    },
    {
        target: '#menu-link-events',
        title: 'Activities',
        content: 'Join fun events, including social activities, training sessions, and new programs. Some are online, while others take place onsite.',
        disableBeacon: true,
    },
    {
        target: '#menu-link-chat',
        title: 'Chat',
        content: 'Build new friendships and find joy in sharing stories and laughter with others.',
        disableBeacon: true,
    },
    {
        target: '#menu-link-cb',
        title: 'Communication Tools',
        content: 'Access communication tools to help you communicate with others.',
        disableBeacon: true,
    },
    {
        target: '#menu-btn-invite',
        title: 'Blue Envelope Program',
        content: 'The Blue Envelope Program offers simple tools: It may help people with special needs communicate with first responders. It may help first responders understand the person\'s special communication needs.',
        disableBeacon: true,
    },
    {
        target: '#menu-general-invite',
        title: 'Search',
        content: 'Easily find members, communities, jobs, volunteer opportunities, events, or any keyword across the platform.',
        disableBeacon: true,
    },
    {
        target: '#search-community-1-form',
        title: 'Community Search',
        content: 'Use this feature to search for specific community names.',
        disableBeacon: true,
    },
    {
        target: '#menu-invitation-leaders',
        title: 'Invitation Leaders',
        content: 'Check out the top inviters! To make this list, send out lots of invitations and have them accepted by your friends.',
        disableBeacon: true,
    },
    {
        target: '#menu-activities-leaders',
        title: 'Activities Leaders',
        content: 'Meet the members with the most activity! To get on this list, engage by making posts, commenting, and liking content.',
        disableBeacon: true,
    },
];

/**
 * Joyride-ready steps — the first step wraps its content in JSX for the bold welcome header.
 * All other steps pass the content string directly (Joyride renders strings fine).
 */
export const joyrideSteps = tourSteps.map((step, index) => {
    if (index === 0) {
        return {
            ...step,
            content: (
                <div className="flex flex-col w-full items-start text-left">
                    <div><b>{step.title}</b></div>
                    <div>{step.content}</div>
                </div>
            ),
        };
    }
    return step;
});
